import { Card, Box, Radio } from "@mui/material";
import MDTypography from "components/MDTypography";
import DoughnutChart from "components/KpiBreakdown/components/DoughnutChart";
import React, { useMemo } from "react";

function computeTotals(payload) {
  const { data, labels, graphKpiColors } = payload;
  const total = data.length && data.reduce((a, v) => a + v);
  const dataIndex = {};
  for (let i = 0; i < data.length; i += 1) {
    dataIndex[i] = data[i];
  }
  const dataIndexArray = Object.entries(dataIndex);
  dataIndexArray.sort((a, b) => b[1] - a[1]);
  const dataOrder = dataIndexArray.map((x) => parseInt(x[0], 10));

  const dataStructure = { labels: [], data: [], colors: [], percentages: [] };
  for (let i = 0; i < data.length; i += 1) {
    dataStructure.labels.push(labels[dataOrder[i]]);
    dataStructure.data.push(data[dataOrder[i]]);
    dataStructure.colors.push(graphKpiColors[dataOrder[i]]);
    dataStructure.percentages.push(Math.round((data[dataOrder[i]] / total) * 100));
  }

  return dataStructure;
}

function BreakDownCharts({ data, graphDisplay, setGraphDisplay }) {
  const { kpiBreakdown, achivedPointsBreakdown } = data;
  const kpiTotals = computeTotals(kpiBreakdown);
  const pointTotals = computeTotals(achivedPointsBreakdown);

  const handleGraphChange = (event) => {
    setGraphDisplay(event.target.value);
  };

  let title = "Achieved Points Breakdown";
  let graphData = pointTotals;
  if (graphDisplay === "kpiBreakdown") {
    title = "Completed KPI Breakdown";
    graphData = kpiTotals;
  }

  return useMemo(
    () => (
      <Card sx={{ height: "388px", maxHeight: "390px", justifyContent: "center" }}>
        <Box
          p={2}
          sx={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <MDTypography
            variant="h6"
            textAlign="center"
            sx={{
              position: "absolute",
              top: "1.5rem",
            }}
          >
            {title}
          </MDTypography>
          <Box
            sx={{
              position: "relative",
              width: "100%",
              maxWidth: "300px",
            }}
          >
            <DoughnutChart dataStructure={graphData} label="" />
          </Box>
          <Box
            display="flex"
            justifyContent="center"
            sx={{
              position: "absolute",
              bottom: 0,
              mb: "0.75rem",
            }}
          >
            <Radio
              checked={graphDisplay === "achievedPointsBreakdown"}
              onChange={handleGraphChange}
              value="achievedPointsBreakdown"
              name="radio-buttons"
              inputProps={{ "aria-label": "Achieved Points Breakdown" }}
            />
            <Radio
              checked={graphDisplay === "kpiBreakdown"}
              onChange={handleGraphChange}
              value="kpiBreakdown"
              name="radio-buttons"
              inputProps={{ "aria-label": "Kpi Breakdown" }}
            />
          </Box>
        </Box>
      </Card>
    ),
    [data, graphDisplay]
  );
}

export default BreakDownCharts;
